import React from 'react';
import moment from 'moment';
import { List, ListItem, MenuItem, ListItemText, Card, CardContent, Avatar, AvatarGroup, Tooltip } from '@mui/material';
import useTranslation from 'Hooks/useTranslation';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import IconButton from '@mui/material/IconButton';
import { CardContentStyle, CardInformation, CardSettings, AvatarGroupStyle } from './style';

export default function ListItemsContainer({ items = [] }) {
  const { t2 } = useTranslation('Generic');
  return (
    <List>
      {items.map((item, index) => (
        <ListItem key={index} style={{ paddingTop: '0' }}>
          <Card variant="outlined" style={{ width: '100%' }}>
            <CardContent style={CardContentStyle}>
              <CardInformation>
                <ListItemText
                  primary={item?.name || ''}
                  secondary={
                    `${item?.date}  ${item?.time !== null ? moment(item?.time, 'HH:mm:ss').format('hh:mm A') : t2('AllDay')}` ||
                    ''
                  }
                />
                {/* <div>
                  <AvatarGroup max={4} sx={AvatarGroupStyle} spacing={1}>
                    {item[2].map((member, i) => (
                      <Tooltip key={i} title={member[0]}>
                        <Avatar src={member[1]} />
                      </Tooltip>
                    ))}
                  </AvatarGroup>
                </div> */}
              </CardInformation>
              <div style={CardSettings}>
                <a target="_blank" href={item?.meetUrl} rel="noreferrer">
                  <IconButton style={{ paddingBottom: '0', paddingTop: '0' }}>
                    <InsertLinkIcon />
                  </IconButton>
                </a>
              </div>
            </CardContent>
          </Card>
        </ListItem>
      ))}
    </List>
  );
}
